import { RefObject } from 'react'

import { useRouter } from 'next/router'

import * as S from './styles'
import { useHero } from './useHero'
import { FormContainer } from '../formContainer'
import { Text, Typewriter } from '@/components'
import { useIsVisibleElement } from '@/hooks/useIsVisibleElement'

export type HeroLandingPageBProps = {
  element: RefObject<HTMLDivElement>
}
export const HeroLandingPageB: React.FC<HeroLandingPageBProps> = ({
  element,
}) => {
  const { fontSizes, heroData } = useHero()
  const { element: formElement, elementVisible } = useIsVisibleElement(true)

  const router = useRouter()

  const { headingWords, typewriterWords } = heroData
  return (
    <S.HeroContainer ref={element}>
      <S.TextContainer>
        {headingWords.map((text) => (
          <Text
            key={text + router.locale}
            size={fontSizes.title}
            color="primary"
          >
            {text}
          </Text>
        ))}

        <S.TypewriterContainer
          maxLength={
            typewriterWords.reduce((a, b) => (a.length > b.length ? a : b))
              .length
          }
        >
          <Typewriter texts={typewriterWords} size={fontSizes.title} />
        </S.TypewriterContainer>
      </S.TextContainer>
      <div ref={formElement} />
      <FormContainer
        title={heroData.formTitle}
        nameInputLabel={heroData.nameInputLabel}
        nameInputPlaceholder={heroData.nameInputPlaceholder}
        emailInputLabel={heroData.emailInputLabel}
        emailInputPlaceholder={heroData.emailInputPlaceholder}
        phoneInputLabel={heroData.phoneInputLabel}
        phoneInputPlaceholder={heroData.phoneInputPlaceholder}
        buttonText={heroData.buttonText}
        buttonTextSuccess={heroData.buttonTextSuccess}
        elementVisible={elementVisible}
      />
    </S.HeroContainer>
  )
}
